<div class="h1-block-header dialog-header">
  <span translate translation="killobsWarning" data-test-id="text-killobs-warning"></span>
</div>
<ng-container *ngIf="(language$ | async) === languages.RU">
  В загруженном демо параметр df_ob_killobs установлен в 0, что позволяет использовать овербаунсы. Это не запрещено
  правилами, но рандомные овербаунсы могут стать причиной того, что демо будет отклонено при валидации, в случае если
  демо займет первое место на турнире, либо если овербаунс даст преимущество, которое повлияет на распределение мест в
  итоговой таблице турнира. Если в прохождении не планировалось использовать стабильные овербаунсы, рекомендуется
  установить параметр df_ob_killobs 1. Рандомные овербаунсы описаны в правилах турниров в пункте 6.3.
</ng-container>
<ng-container *ngIf="(language$ | async) === languages.EN">
  In the uploaded demo, the df_ob_killobs parameter is set to 0, which allows overbounces. This is not prohibited by the
  rules, but random overbounces can cause the demo to be rejected during validation if the demo takes first place in the
  tournament, or if overbounce gives an advantage that will affect the distribution of places in the final tournament
  table. If you didn't plan to use stable overbounces, it is recommended to set the df_ob_killobs parameter to 1. Random
  overbounces are described in the tournament rules in section 6.3.
</ng-container>
<button
  (click)="closeDialog()"
  mat-raised-button
  color="primary"
>
  <span>OK</span>
</button>